import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart, Cpu } from 'lucide-react';
import { Button } from './Button';
export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Sistemas',
    path: '/catalog'
  }, {
    name: 'Laboratorio',
    path: '/about'
  }, {
    name: 'Contacto',
    path: '/contact'
  }];
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'glass-panel py-4' : 'bg-transparent py-6'}`} data-id="element-73">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-74">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-75">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-lab-violet to-lab-blue flex items-center justify-center shadow-[0_0_15px_rgba(109,40,217,0.5)] group-hover:shadow-[0_0_25px_rgba(109,40,217,0.8)] transition-all" data-id="element-76">
              <Cpu size={18} className="text-white" data-id="element-77" />
            </div>
            <span className="font-display font-bold text-lg tracking-widest text-white" data-id="element-78">
              CLVN<span className="text-lab-muted font-light" data-id="element-79">–</span>LRR
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-80">
            <div className="flex items-center gap-6 glass-panel px-6 py-2 rounded-full" data-id="element-81">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-white ${location.pathname === link.path ? 'text-white' : 'text-lab-muted'}`} data-id="element-82">
                  {link.name}
                </Link>)}
            </div>

            <div className="flex items-center gap-4" data-id="element-83">
              <button className="text-lab-muted hover:text-white transition-colors relative" data-id="element-84">
                <ShoppingCart size={20} data-id="element-85" />
                <span className="absolute -top-1 -right-1 w-2 h-2 bg-lab-violetLight rounded-full shadow-[0_0_10px_rgba(139,92,246,0.8)]" data-id="element-86"></span>
              </button>
              <Link to="/catalog" data-id="element-87">
                <Button variant="primary" size="sm" data-id="element-88">
                  Acceso
                </Button>
              </Link>
            </div>
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden flex items-center gap-4" data-id="element-89">
            <button className="text-lab-muted hover:text-white transition-colors relative" data-id="element-90">
              <ShoppingCart size={20} data-id="element-91" />
            </button>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white p-2" data-id="element-92">
              {mobileMenuOpen ? <X size={24} data-id="element-93" /> : <Menu size={24} data-id="element-94" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-95">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-lab-black/95 backdrop-blur-xl pt-24 px-6" data-id="element-96">
            <div className="flex flex-col gap-6 text-center" data-id="element-97">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="text-2xl font-display font-medium text-white/80 hover:text-white" data-id="element-98">
                  {link.name}
                </Link>)}
              <div className="mt-8 pt-8 border-t border-white/10 flex flex-col gap-4" data-id="element-99">
                <Link to="/catalog" className="w-full" data-id="element-100">
                  <Button variant="primary" fullWidth data-id="element-101">
                    Acceso al Laboratorio
                  </Button>
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};